import Landing from "@/components/sharedComponents/landing/landing.component";
import TokenComponent from "@/components/Token/token.component";
import { LandingItem } from "@/interfaces/landingItem";
import { PageTitleComponent } from "helix-vue-components";
import { Component, Vue } from "vue-property-decorator";
import Template from "./SettingsMainMenu.template.vue";

@Component({
  mixins: [Template],
  components: {
    Landing,
    PageTitleComponent,
    TokenComponent
  }
})
export default class SettingsMainMenuComponent extends Vue {
  public landingOptions: LandingItem[] = [
    {
      namedRoute: "permission-management-list",
      icon: "fa-user-friends",
      translationString: "permission_management"
    },
    {
      namedRoute: "location-management-list",
      icon: "fa-building",
      translationString: "location.location_management"
    },
    {
      namedRoute: "user-management-list",
      icon: "fa-user",
      translationString: "user_management"
    },
    {
      namedRoute: "location-api-management",
      icon: "fa-puzzle-piece",
      translationString: "loc-api.title"
    }
  ];
  public showCurrentToken() {
    this.$modals.load(TokenComponent);
  }
}
